import { createSlice } from '@reduxjs/toolkit';
import { resetApplication } from '../application/slice';
import customerSpaceRequestState from './state';
const customerSpaceRequestSlice = createSlice({
    extraReducers: builder => {
        builder.addCase(resetApplication, () => customerSpaceRequestState);
    },
    initialState: customerSpaceRequestState,
    name: 'customerSpaceRequest',
    reducers: {
        errorReceiveCustomerSpaceRequest: state => {
            state.requestingCustomerSpaceRequest = false;
        },
        failedReceiveCustomerSpaceRequest: state => {
            state.requestingCustomerSpaceRequest = false;
        },
        receiveCustomerSpaceRequest: state => {
            state.requestingCustomerSpaceRequest = false;
        },
        requestCustomerSpaceRequest: {
            prepare: (siteInformation, emailAddress, rackVolume, powerNeeds, requirements) => {
                return {
                    payload: {
                        emailAddress,
                        powerNeeds,
                        rackVolume,
                        requirements,
                        siteInformation
                    }
                };
            },
            reducer: state => {
                state.requestingCustomerSpaceRequest = true;
            }
        },
        resetCustomerSpaceRequest: () => customerSpaceRequestState
    }
});
export const { errorReceiveCustomerSpaceRequest, failedReceiveCustomerSpaceRequest, receiveCustomerSpaceRequest, requestCustomerSpaceRequest, resetCustomerSpaceRequest } = customerSpaceRequestSlice.actions;
export default customerSpaceRequestSlice.reducer;
